// import moment from 'moment';

import jwtDecode from 'jwt-decode';

import application from 'application/application';

application.factory('authentication', () => {
	return {
		isLogged() {
			var expires = localStorage.getItem('__expires_in__');

			var authenticationToken = localStorage.getItem('__authenticationToken__');

			if (expires && authenticationToken) {
				var dateNew = new Date();
				var dateExpires = new Date(expires);

				return dateExpires > dateNew;
			}

			return false;
		},
		signIn(data, callback) {
			let user;

			// Usando try catch de não conseguir fazer o decode do token
			try {
				// Somente as propriedades importantes ou relevantes
				const {
					exp,
					nome,
					email,
					login,
					idPessoa,
					idCliente,
					idTipoUsuario,
					idUsuarioAcesso,
					idUsuarioCliente,
					flUsuarioAdministrador,
					idProdutoAdvise,
					primeiroAcesso
				} = jwtDecode(data['access_token']);

				user = {
					exp,
					nome,
					email,
					login,
					idPessoa,
					idCliente,
					idTipoUsuario,
					idUsuarioAcesso,
					idUsuarioCliente,
					flUsuarioAdministrador,
					idProdutoAdvise,
					primeiroAcesso:
						primeiroAcesso && primeiroAcesso === 'true' ? true : false
				};
			} catch (error) {
				user = JSON.stringify({});
			}

			localStorage.setItem('__authenticationToken__', data['access_token']);

			localStorage.setItem('__authenticationTokenType__', data['token_type']);

			localStorage.setItem(
				'__authenticationRefreshToken__',
				data['refresh_token']
			);

			// localStorage.setItem(
			// 	'__authenticationExpires__',
			// 	new Date(data['.expires']).toISOString()
			// );

			localStorage.setItem('__authenticationUserData__', JSON.stringify(user));

			typeof callback === 'function' && callback();
		},
		getUserData(key) {
			var authenticationUserData = JSON.parse(
				localStorage.getItem('__authenticationUserData__')
			);

			return authenticationUserData &&
				authenticationUserData.hasOwnProperty(key)
				? authenticationUserData[key]
				: undefined;
		},
		updateUserData(data = {}) {
			var authenticationUserData = JSON.parse(
				localStorage.getItem('__authenticationUserData__')
			);

			Object.keys(data).forEach(item => {
				authenticationUserData[item] = data[item];
			});

			localStorage.setItem(
				'__authenticationUserData__',
				JSON.stringify(authenticationUserData)
			);
		}
	};
});
